export default {
  'report.name': 'Báo cáo tổng',
  'report.title': 'Báo cáo tổng',
}